module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.options), function(item, index) {
    return (_vm.options != null) ? _c('div', {
      key: index,
      staticClass: "layui-unselect layui-form-radio",
      class: {
        'layui-form-radioed': _vm.currentValue.Value == item.Value
      },
      on: {
        "click": function($event) {
          _vm.changeRadio(item)
        }
      }
    }, [_c('i', {
      staticClass: "layui-anim layui-icon",
      class: {
        'layui-anim-scaleSpring': _vm.currentValue.Value == item.Value
      }
    }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.Text))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.optionVals), function(item, index) {
    return (_vm.optionVals != null) ? _c('div', {
      key: index,
      staticClass: "layui-unselect layui-form-radio",
      class: {
        'layui-form-radioed': _vm.currentVal == item
      },
      on: {
        "click": function($event) {
          _vm.changeRadio(item)
        }
      }
    }, [_c('i', {
      staticClass: "layui-anim layui-icon",
      class: {
        'layui-anim-scaleSpring': _vm.currentVal == item
      }
    }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-add1dfde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmRadio.vue
// module id = 608
// module chunks = 2